module.exports = __webpack_public_path__ + "static/media/data_source_bg_mobile.eff19e22.jpg";